import {getFavoriteCookie} from "@js/globalFunctions/cookieHandling";

export function initFavoriteBasket() {
	const cookieTest = getFavoriteCookie();

	if (cookieTest && (cookieTest.length > 0)) {
		$('#fav-basket').removeClass('empty');
		$('#fav-basket-special').removeClass('empty');
		const favouritesArray = JSON.parse(cookieTest)
		$('#fav-count').text(favouritesArray.length);
		$('#fav-count-special').text(favouritesArray.length);
	} else {
		$('#award-link').removeClass('hidden');
		$('#tuv-link').removeClass('hidden');
	}
	
}
